(function () {
    $(function () {
        const defaults = {
            blinkTimeout: 50
        }
        
        // todo сделать добавление ошибки в блок по передаваемому селектору ?
        $(document).on('inputError', '.ui-input-bordered', (event, data) => {
            const $target = $(event.target)
            $target.siblings('.ui-input-error').remove()
            const $error = $(`<div class="ui-input-error">${data.text}</div>`)
            $target.addClass('ui-input-bordered_state-error').after($error)
            setTimeout(() => {
                $error.addClass('ui-input-error_state-visible')
            }, defaults.blinkTimeout)
        })
        $(document).on('inputResolveErrors', '.ui-input-bordered', event => {
            const $target = $(event.target)
            $target.removeClass('ui-input-bordered_state-error').siblings('.ui-input-error').remove()
        })
    })
}());
